<template>
  <div>
    <Breadcrumbs title="Profile"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>